import Pie from './_Pie'

export default Pie
